import { Save, X } from "lucide-react";
import { useState } from "react";

import MediaUploader from "./MediaUploader";

const blankVehicle = {
  main_image: "",
  gallery: [],
  brand: "",
  model: "",
  variant: "",
  year: new Date().getFullYear(),
  km: 0,
  fuel: "Elektrisk",
  transmission: "Automat",
  price: 0,
  description: "",
  source: "manual",
  sync_status: "manual",
  external_finn_id: null,
  finn_link: null,
  published: true,
  featured: true,
};

export function AdminVehicleEditor({ saving, vehicle, onCancel, onSave }) {
  const [form, setForm] = useState(vehicle || blankVehicle);
  const update = (event) => {
    const { name, value } = event.target;
    setForm({ ...form, [name]: ["year", "km", "price"].includes(name) ? Number(value) : value });
  };

  return (
    <section className="vehicle-edit" data-testid="vehicle-editor">
      <div className="admin-section-title">
        <div><p className="section-eyebrow">{vehicle?.id ? "Rediger" : "Ny"} bil</p><h2>{vehicle?.id ? `${vehicle.brand} ${vehicle.model}` : "Legg til bil"}</h2></div>
        <button aria-label="Avbryt" className="icon-button" data-testid="cancel-vehicle-edit-button" onClick={onCancel}><X size={18} /></button>
      </div>
      <div className="admin-form-grid">
        <label>Merke<input data-testid="vehicle-brand-input" name="brand" value={form.brand} onChange={update} /></label>
        <label>Modell<input data-testid="vehicle-model-input" name="model" value={form.model} onChange={update} /></label>
        <label>Variant<input data-testid="vehicle-variant-input" name="variant" value={form.variant} onChange={update} /></label>
        <label>Årsmodell<input data-testid="vehicle-year-input" name="year" type="number" value={form.year} onChange={update} /></label>
        <label>Kilometer<input data-testid="vehicle-km-input" name="km" type="number" value={form.km} onChange={update} /></label>
        <label>Pris<input data-testid="vehicle-price-input" name="price" type="number" value={form.price} onChange={update} /></label>
        <label>Drivstoff<input data-testid="vehicle-fuel-input" name="fuel" value={form.fuel} onChange={update} /></label>
        <label>Girkasse<input data-testid="vehicle-transmission-input" name="transmission" value={form.transmission} onChange={update} /></label>
        <label className="full-span">FINN-lenke<input data-testid="vehicle-finn-link-input" name="finn_link" placeholder="https://www.finn.no/..." value={form.finn_link || ""} onChange={update} /></label>
        <label className="full-span">Hovedbilde (URL)<input data-testid="vehicle-image-input" name="main_image" value={form.main_image} onChange={update} /></label>
        <label className="full-span">Beskrivelse<textarea data-testid="vehicle-description-input" name="description" value={form.description} onChange={update} /></label>
      </div>
      <MediaUploader accept="image/jpeg,image/png,image/webp" kind="image" onUploaded={(url) => setForm({ ...form, main_image: url })} testId="vehicle-image" />
      <div className="editor-actions"><button className="button button--outline" data-testid="cancel-vehicle-button" onClick={onCancel}>Avbryt</button><button className="button button--light" data-testid="save-vehicle-button" disabled={saving} onClick={() => onSave(form)}><Save size={16} />{saving ? "Lagrer..." : "Lagre bil"}</button></div>
    </section>
  );
}